import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import themeable from 'zignal-landscape/lib/themeable';
import Card from 'zignal-landscape/lib/Card';
import FilterHideIcon from 'zignal-landscape/lib/Icon/FilterHideIcon';
import Label from 'zignal-landscape/lib/Label';
import Radio from 'zignal-landscape/lib/Radio';
import Select from 'zignal-landscape/lib/Select';
import { VIEW_BY_OPTIONS } from '../../constants';

import AutomationScoreSlider from './components/AutomationScoreSlider';

class DisplayOptions extends React.Component {

  shouldComponentUpdate(nextProps) {
    const curProps = this.props;

    const shouldViewOrfilteredClustersUpdate = () => {
      const curView = curProps.selectedViewByOption.value;
      const getFilteredClusterNodesLength = ({filteredClusterNodes}) => {
        return (filteredClusterNodes[curView] || []).length;
      };
      // first check if the view is changing
      if (curView !== nextProps.selectedViewByOption.value) {
        return true;
      }
      // onlt then bother to check the filteredClusterNodes
      return getFilteredClusterNodesLength(curProps) !== getFilteredClusterNodesLength(nextProps);
    };

    return (
      curProps.viewBy !== nextProps.viewBy
      || curProps.lastSearchBy !== nextProps.lastSearchBy
      || curProps.filteredAutomationScore !== nextProps.filteredAutomationScore
      || curProps.selectedSizeNodeByOption.value !== nextProps.selectedSizeNodeByOption.value
      || shouldViewOrfilteredClustersUpdate()
    );
  }

  render() {
    const {
      styles,
      viewBy,
      toggleViewByOption,
      additionalFilterOptions,
      filteredViewByOptions,
      sizeNodesByOptions,
      setfilteredClusterNodes,
      filteredClusterNodes,
      selectedSizeNodeByOption,
      selectedViewByOption,
      setSelectedViewByOption,
      setSelectedSizeNodesByOption,
      toggleMenuPanelVisibility,
      filteredAutomationScore,
      filterAutomationScore,
      toggleUnknownFilter,
    } = this.props;

    const viewByDropDownLabel = viewBy === 'cluster'
      ? 'Cluster'
      : 'Categorize';

    const cx = classNames.bind(styles); // eslint-disable-line react/jsx-no-bind

    const selectStyles = {
      singleValue: base => ({
        ...base,
        padding: 0,
        lineHeight: 'inherit',
        color: 'rgb(180, 191, 214)'
      }),
      valueContainer: base => ({ ...base, padding: '0 7px' })
    };

    const getOptionValue = (option) => option.value.split('|').slice(1).join('|');
    let selectedAdditionFilterValues = [];
    const { enableFilter } = VIEW_BY_OPTIONS.all.find(({value}) => value === selectedViewByOption.value) || {};
    if(enableFilter && filteredClusterNodes[selectedViewByOption.value]){
      selectedAdditionFilterValues = additionalFilterOptions
        .reduce((acc, node) => {
          return acc.concat(node.options);
        },[])
        .filter((option) => filteredClusterNodes[selectedViewByOption.value].includes(getOptionValue(option)));
    }


    const additionalFilter =(options, type) => (
      <div className={styles.optionMargin}>
        <Select
          id="additionalFilter"
          placeholder={options.length ? `Select ${type}` : `No ${type} available...`}
          options={options}
          onChange={(selectedOptions) => {
            const selectedNodes = {};
            if(selectedOptions.length) {
              selectedNodes[type]= selectedOptions.map(getOptionValue);
            }
            setfilteredClusterNodes(selectedNodes);
          }}
          value={selectedAdditionFilterValues}
          isMulti
          isClearable
        />
      </div>);

    return (
      <Card>
        <div className={styles.displayOptionsContainer}>
          <div className={styles.iconPosition} onClick={toggleMenuPanelVisibility}>
            <FilterHideIcon />
          </div>
          <div>
            <Label size="large">Display Options</Label>
          </div>
          <div className={styles.optionMargin}>
            <Label>View</Label>
            <Radio
              id="cluster"
              name="viewBy"
              value="cluster"
              checked={viewBy === 'cluster'}
              onChange={toggleViewByOption}
            />
            <Label htmlFor="cluster" inline>Cluster</Label>
            <Radio
              id="category"
              name="viewBy"
              value="category"
              checked={viewBy === 'category'}
              onChange={toggleViewByOption}
            />
            <Label htmlFor="category" inline>Category</Label>
          </div>
          <div className={styles.optionMargin}>
            <Label>{viewByDropDownLabel} by</Label>
            <Select
              key="view-by-dropdown"
              id="view-by-dropdown"
              options={filteredViewByOptions}
              value={selectedViewByOption}
              onChange={setSelectedViewByOption}
              selectStyles={selectStyles}
            />
          </div>
          {
            enableFilter && additionalFilter(additionalFilterOptions, selectedViewByOption.value)
          }
          <div className={styles.optionMargin}>
            <Label>Size Nodes by</Label>
            <Select
              key="nodes-by-dropdown"
              id="nodes-by-dropdown"
              options={sizeNodesByOptions}
              value={selectedSizeNodeByOption}
              onChange={setSelectedSizeNodesByOption}
              selectStyles={selectStyles}
            />
          </div>
          <div className={styles.optionMargin}>
            <AutomationScoreSlider
              min={filteredAutomationScore.min}
              max={filteredAutomationScore.max}
              isUnknownIncluded={filteredAutomationScore.isUnknownIncluded}
              toggleUnknownIncluded={toggleUnknownFilter}
              setMinAndMaxValues={filterAutomationScore}
            />
          </div>
        </div>
      </Card>
    );
  }

}

DisplayOptions.propTypes = {
  styles: PropTypes.object.isRequired,
  filteredAutomationScore: PropTypes.object.isRequired,
  selectedViewByOption: PropTypes.object,
  selectedSizeNodeByOption: PropTypes.object,
  viewBy: PropTypes.string,
  filteredViewByOptions: PropTypes.array,
  sizeNodesByOptions: PropTypes.array,
  filteredClusterNodes: PropTypes.object,
  additionalFilterOptions: PropTypes.array,
  toggleViewByOption: PropTypes.func,
  setSelectedViewByOption: PropTypes.func,
  setfilteredClusterNodes: PropTypes.func,
  setSelectedSizeNodesByOption: PropTypes.func,
  toggleMenuPanelVisibility: PropTypes.func,
  lastSearchBy: PropTypes.string,
  filterAutomationScore: PropTypes.func,
  toggleUnknownFilter: PropTypes.func,
  selectClusters: PropTypes.func,
};

DisplayOptions.defaultProps = {};

export default themeable(DisplayOptions);
